import React from 'react';

const checkBox = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	let dispContent = fieldDetail.options.map((arr,i) => {
		return <input type="checkBox" key={i} name={props.fieldKey} value={fieldDetail.value} onChange={props.changed}/>;
	});
	return (
            <div className="form-group">
              <label className="pl-0">{fieldDetail.title}</label><br/>   
              {dispContent}        
           	</div> 
	);
}

export default checkBox;